/* @flow */
import RolePicker from './RolePicker';

export default RolePicker;
